import { render, staticRenderFns } from "./director_change.vue?vue&type=template&id=5f25e4ef&"
import script from "./director_change.vue?vue&type=script&lang=js&"
export * from "./director_change.vue?vue&type=script&lang=js&"
import style0 from "./director_change.vue?vue&type=style&index=0&id=5f25e4ef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports